module.exports = __webpack_public_path__ + "static/img/pinJie3.526a892.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pinJie3.png
// module id = T4yl
// module chunks = 2